module.exports = __webpack_public_path__ + "img/41_13.83049d82.png";